import React from 'react';
import { useLanguage } from '../../i18n/useLanguage';
import { StaticPage } from '../StaticPage';
import { faqItemsDe } from './faq/faqItemsDe';
import { faqItemsEn } from './faq/faqItemsEn';

export const FAQPage: React.FC = () => {
  const { language } = useLanguage();
  const faqs = language === 'de' ? faqItemsDe : faqItemsEn;

  return (
    <StaticPage titleKey="static.faq">
      <div className="faq-list">
        {faqs.map((item, i) => (
          <details key={i} className="faq-item">
            <summary className="faq-question">{item.q}</summary>
            <div className="faq-answer">{item.a}</div>
          </details>
        ))}
      </div>
    </StaticPage>
  );
};
